import Deepak from "../img/team/deepak.jpg";
import Aashutosh from "../img/team/aasutosh.jpg";
import Abhishek from "../img/team/abhishek.png";
import Abhishekkumar from "../img/team/abhishekkumar.jpg";
import Aditi from "../img/team/aditi.jpg";
import Aman from "../img/team/aman.jpg";
import Amisha from "../img/team/amisha.jpg";
import Ashirbad from "../img/team/ashirbad.jpg";
import Atman from "../img/team/atman.jpg";
import Bharat from "../img/team/bharat.jpg";
import Bunny from "../img/team/bunny.jpg";
import Divanti from "../img/team/divanti.jpeg";
import Ippsa from "../img/team/ippsa.jpg";
import Nausin from "../img/team/nausin.jpg";
import Rajeev from "../img/team/rajeev.jpg";
import Ramraaj from "../img/team/ramraaj.jpg";
import Ritesh from "../img/team/ritesh.jpg";
import Rukaiya from "../img/team/rukaiya.jpg";
import Samar from "../img/team/samar.jpg";
import Saumya from "../img/team/saumya.jpg";
import Saurabh from "../img/team/saurabh.jpg";
import Sidharth from "../img/team/sidharth.jpg";
import Snata from "../img/team/snata.jpg";
import Snehashis from "../img/team/snehashis.jpg";
import Swapnali from "../img/team/swapnali.jpg";
import Yash from "../img/team/yash.png";
import SagarSourav from "../img/team/sagar_saurav.jpg";
import NabaRatan from "../img/team/naba.jpg";
import Harshit from "../img/team/harshit.jpg";
import Rashmi from "../img/team/rashmi.jpg";
import Monalisa from "../img/team/monalisa.jpg";
import Rajarshi from "../img/team/Rajarshi.jpeg";
import Sibasis from "../img/team/sibasis.jpg";
import Abhishekgiri from "../img/team/abhishekgiri.jpg";
import Meenakshi from "../img/team/meenakshi.jpg";
import Abhidey from "../img/team/abhidey.jpg";

// fontawesome
import { faLinkedin, faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";

// data
export const Lead = {
  src: Aman,
  name: "Aman Irshad",
  des: "DSC Lead",
  social: [
    { href: "https://www.linkedin.com/mwlite/in/amanirshad", icon: faLinkedin },
    { href: "https://www.instagram.com/amanirshad7/", icon: faInstagram },
    { href: "https://mobile.twitter.com/AmanIrshad7", icon: faTwitter },
  ],
};

export const Faculties = [
  {
    src: Monalisa,
    name: "Monalisa Mishra",
    des: "Faculty Advisor",
    social: [{ href: "#", icon: faInstagram }],
  },
  {
    src: Rashmi,
    name: "Rasmi Ranjan Khansama",
    des: "Mentor",
    social: [
      {
        href: "https://www.facebook.com/rasmiranjan.khansama",
        icon: faFacebook,
      },
      {
        href: "https://www.linkedin.com/in/rasmi-ranjan-khansama-29325169/",
        icon: faLinkedin,
      },
    ],
  },
];

export const Board_members = [
  {
    src: Ritesh,
    name: "Ritesh Kumar Sinha",
    des: "Technical Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/ritesh-kumar-sinha-8558861a7/",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/riteshsinha70/", icon: faInstagram },
      { href: "https://twitter.com/Riteshk86822970?s=08", icon: faTwitter },
    ],
  },
  {
    src: Deepak,
    name: "Deepak Kumar Sahoo",
    des: "Project lead",
    social: [
      {
        href: "https://www.linkedin.com/in/deepak-kumar-sahoo-59247b19a/",
        icon: faLinkedin,
      },
      {
        href: "https://www.instagram.com/_kumar_deepak_321/",
        icon: faInstagram,
      },
      { href: "https://twitter.com/DEEPAKK60928454", icon: faTwitter },
    ],
  },
  {
    src: Saumya,
    name: "Saumya Srivastava",
    des: "Operation Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/saumya-srivastava-703bb31ab/",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/saumya3215/", icon: faInstagram },
    ],
  },
  {
    src: Ippsa,
    name: "Ippsa Mahana",
    des: "Management Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/ippsa-mahana-0577b2193/",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/__ippsaaa__/", icon: faInstagram },
      { href: "https://twitter.com/asppi2806", icon: faTwitter },
    ],
  },
];

export const Technical_team = [
  {
    src: Atman,
    name: "Atman Das",
    des: "Web Development Lead",
    social: [
      { href: "https://www.linkedin.com/in/atmanad/", icon: faLinkedin },
      { href: "https://www.instagram.com/__gh00st/", icon: faInstagram },
    ],
  },
  {
    src: Rukaiya,
    name: "Rukaiya Khan",
    des: "Associate Web development Lead",
    social: [
      { href: "https://www.linkedin.com/in/rukaiyak/", icon: faLinkedin },
      { href: "https://www.instagram.com/rukaiyak_/", icon: faInstagram },
      { href: "https://twitter.com/ruk_____", icon: faTwitter },
    ],
  },
  {
    src: Snehashis,
    name: "Snehasish Pati",
    des: "Associate Web development Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/snehashis-pati-536bb81aa",
        icon: faLinkedin,
      },
      {
        href: "https://instagram.com/snehasish_pati?igshid=1h8nzdltxttwz",
        icon: faInstagram,
      },
      { href: "https://twitter.com/Snehashis2001", icon: faTwitter },
    ],
  },
  {
    src: Sidharth,
    name: "Sidharth Bhunia",
    des: "Android Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/sidharth-bhunia-563852190",
        icon: faLinkedin,
      },
    ],
  },
  {
    src: Rajeev,
    name: "Rajeev kumar",
    des: "Associate Android Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/rajeev-kumar-541a631a0",
        icon: faLinkedin,
      },
      {
        href: "https://www.instagram.com/_rajeev__kumar_?r=nametag",
        icon: faInstagram,
      },
    ],
  },
  {
    src: Abhishekkumar,
    name: "Abhishek Kumar",
    des: "Android Lead(Flutter)",
    social: [
      {
        href: "https://www.linkedin.com/in/iamabhishek77/",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/iamabhishek_77/", icon: faInstagram },
      { href: "https://twitter.com/iamabhishek_77", icon: faTwitter },
    ],
  },
  {
    src: Bunny,
    name: "Shubham Gaurav",
    des: "Competitive Coding Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/shubham-gaurav-a86090192",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/bunny_gaurav/", icon: faInstagram },
    ],
  },
  {
    src: Samar,
    name: "Samar Chandra",
    des: "Associate Competitive Coding Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/samar-chandra-5255651b3/",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/_i.samar/", icon: faInstagram },
      { href: "https://mobile.twitter.com/SamarChandra7", icon: faTwitter },
    ],
  },
  {
    src: Rajarshi,
    name: "Rajarshi Pal",
    des: "Associate Competitive Coding Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/rajarshi-pal-269a921aa/",
        icon: faLinkedin,
      },
      {
        href: "https://www.instagram.com/__amante_imperioso__",
        icon: faInstagram,
      },
    ],
  },
  {
    src: Yash,
    name: "Yashraj Jain",
    des: "ML Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/yashraj-jain-695453178/",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/_infynite/", icon: faInstagram },
      { href: "https://twitter.com/yashrajjain726", icon: faTwitter },
    ],
  },
  {
    src: Amisha,
    name: "Amisha Kirti",
    des: "Associate ML Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/amisha-kirti-79410716a",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/kirti_amisha/", icon: faInstagram },
      { href: "https://mobile.twitter.com/kirtiastic", icon: faTwitter },
    ],
  },
  {
    src: Aashutosh,
    name: "Aashutosh Agrahari",
    des: "Associate ML lead",
    social: [
      {
        href: "https://www.linkedin.com/in/aashutosh-agrahari-3ba6421b6",
        icon: faLinkedin,
      },
      {
        href: "https://www.instagram.com/aashutoshagrahari/",
        icon: faInstagram,
      },
      { href: "https://twitter.com/yashrajjain726", icon: faTwitter },
    ],
  },
  {
    src: Ramraaj,
    name: "Ramraaj Bishnoie",
    des: "Associate ML Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/ramraj-bishnoie-52784240",
        icon: faLinkedin,
      },
      {
        href: "https://instagram.com/_bazor_",
        icon: faInstagram,
      },
    ],
  },
  {
    src: Abhidey,
    name: "Abhishake Banerjee",
    des: "Cyber Security Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/abhishake-banerjee-33a7301b1/",
        icon: faLinkedin,
      },
      {
        href: "https://www.instagram.com/ph4nt0m_0f_f1r3/",
        icon: faInstagram,
      },
      { href: "https://twitter.com/abhisha27795619", icon: faTwitter },
    ],
  },
  {
    src: NabaRatan,
    name: "Naba Ratan Patra",
    des: "Associate Cyber Security Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/naba-ratan-b904991a7/",
        icon: faLinkedin,
      },
      {
        href: "https://www.instagram.com/nabaratanpatra/",
        icon: faInstagram,
      },
      { href: "https://twitter.com/RatanNaba", icon: faTwitter },
    ],
  },
];

export const Design_team = [
  {
    src: Snata,
    name: "Snata Gayan",
    des: "Designing Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/snata-gayan-5b349b19b/",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/s.n.a.t.a_/", icon: faInstagram },
      { href: "https://twitter.com/GayanSnata", icon: faTwitter },
    ],
  },
  {
    src: Sibasis,
    name: "Sibasis Rath",
    des: "Associate Designing Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/sibasis-rath-1233411a7",
        icon: faLinkedin,
      },
    ],
  },
];

export const Management_team = [
  {
    src: Saurabh,
    name: "Saurabh Kumar",
    des: "Marketing and Sponsorship Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/saurabh-kumar-7214aa176/",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/_ska_03/", icon: faInstagram },
    ],
  },
  {
    src: Aditi,
    name: "Aditi Kumari",
    des: "Associate Marketing and Sponsorship lead",
    social: [
      {
        href: "https://www.linkedin.com/in/aditi-kumari-65797a1ab",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/aditi_sah143", icon: faInstagram },
    ],
  },
  {
    src: Ashirbad,
    name: "Ashirbad Nayak",
    des: "Associate Marketing and Sponsorship Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/ashirbad-nayak-5515491b1",
        icon: faLinkedin,
      },
      { href: "https://instagram.com/aditi_sah143", icon: faInstagram },
    ],
  },
  {
    src: Bharat,
    name: "Bharat Shubham",
    des: "Manager",
    social: [
      {
        href: "https://www.linkedin.com/in/bharat-shubham-6b5808190/",
        icon: faLinkedin,
      },
      {
        href: "https://www.instagram.com/bharatshubham5/",
        icon: faInstagram,
      },
      { href: "https://twitter.com/BharatShubham10?s=08", icon: faTwitter },
    ],
  },
  {
    src: Abhishekgiri,
    name: "Abhishek Giri",
    des: "Manager",
    social: [
      {
        href: "https://www.linkedin.com/in/abhishek-giri-03a18b1b9",
        icon: faLinkedin,
      },
      {
        href: "https://instagram.com/oye_giri?igshid=qdzxtni1u7yn",
        icon: faInstagram,
      },
      { href: "https://twitter.com/Oye_Giri?s=09", icon: faTwitter },
    ],
  },
  {
    src: Meenakshi,
    name: "Meenakshi",
    des: "Manager",
    social: [
      {
        href: "https://www.linkedin.com/in/meenakshi-gupta-228b71192",
        icon: faLinkedin,
      },
      {
        href: "https://instagram.com/_.miss_psychopath._?igshid=55pzj70cxyon",
        icon: faInstagram,
      },
    ],
  },
  {
    src: Divanti,
    name: "Divanti Neogi",
    des: "Editorial Manager",
    social: [
      { href: "linkedin.com/in/divanti-neogi-20111219b", icon: faLinkedin },
      { href: "https://www.instagram.com/_divss__/", icon: faInstagram },
      { href: "https://twitter.com/DivantiNeogi?s=09", icon: faTwitter },
    ],
  },
  {
    src: Swapnali,
    name: "Swapnali Gouda",
    des: "Editorial Head",
    social: [
      {
        href: "https://www.linkedin.com/in/swapnali-gouda-5bb7371a6/",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/__cerca_trova_/", icon: faInstagram },
    ],
  },
  {
    src: Nausin,
    name: "Nausin Nigar",
    des: "Associate Management Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/nausin-nigar-87a0951a9",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/nausin_nigar/", icon: faInstagram },
      { href: "https://twitter.com/NausinNigar", icon: faTwitter },
    ],
  },
  {
    src: Harshit,
    name: "P. Harshit",
    des: "Creatives and Photography Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/p-harshit-4a72621b7",
        icon: faLinkedin,
      },
      {
        href: "https://instagram.com/_m_a_d_m_a_x_x_18?igshid=1f4qjney152ws",
        icon: faInstagram,
      },
      { href: "https://twitter.com/RaoHarshit2?s=08", icon: faTwitter },
    ],
  },
];

export const Public_relation_team = [
  {
    src: Abhishek,
    name: "Abhishek Dey",
    des: "Public Relation Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/abhishek-dey-098246195",
        icon: faLinkedin,
      },
    ],
  },
  {
    src: SagarSourav,
    name: "Sagar Saurav Behera",
    des: "Associate Public Relation Lead",
    social: [
      {
        href: "https://www.linkedin.com/in/sagar-saurav-behera-556a37136/",
        icon: faLinkedin,
      },
      { href: "https://www.instagram.com/the_damn_leo/", icon: faInstagram },
    ],
  },
];
